/**
 * LocalStorage / SessionStorage Keys Constants
 * @description Centralized management of all storage keys to ensure type safety and prevent typos
 */
export const STORAGE_KEYS = {
  USER_STORE_V2: 'mech3d-user-v2',
  USER_STORE_V1: 'mech3d-user',
  ADMIN_TOKEN: 'admin_token',
  USER_TOKEN: 'user_token',
  LEGACY_TOKEN: 'token',
  LEGACY_USER_INFO: 'userInfo',
  LEGACY_REFRESH_TOKEN: 'refreshToken',
  REMEMBER_ME: 'mech3d_remember_me',
  SAVED_CREDENTIALS: 'mech3d_saved_credentials',
  ADMIN_RBAC_ROLES: 'admin-rbac-roles',
} as const

export type StorageKey = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS]
